import data from './data';
let index = (function () {
    let result = {};
    Object.assign(result, {});
    Object.assign(result, data);
    return result;
})();

export default index;
